import { render } from "./AddQuestionQCM.vue?vue&type=template&id=c48d4f42&scoped=true&ts=true"
import script from "./AddQuestionQCM.vue?vue&type=script&lang=ts"
export * from "./AddQuestionQCM.vue?vue&type=script&lang=ts"

import "./AddQuestionQCM.vue?vue&type=style&index=0&id=c48d4f42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c48d4f42"]])

export default __exports__